import { getTargets, parseHTML } from '~/helpers';
import { HTMLCustomElement } from '~/html-custom-element';

/**
 * Handles dynamic language options for the selected country.
 *
 * @attribute section-id - The source section.
 */
class LocalizationForm extends HTMLCustomElement {
  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    this.on('change', this.targets.country, this.handleCountrySelect.bind(this));
  }

  /**
   * Handles the country select event.
   * @param {InputEvent} event - The event payload.
   */
  async handleCountrySelect(event) {
    this.targets.language.disabled = true;

    await fetch(`${theme.routes.root_url}?country=${event.target.value}&section_id=${this.getAttribute('section-id')}`)
      .then((response) => response.text())
      .then((response) => {
        const element = parseHTML(response, this.tagName);
        const targets = getTargets(element);

        /**
         * Updates the language options to those available with the selected country.
         */
        this.targets.language.innerHTML = '';

        [...targets.language.options].forEach((option) => {
          this.targets.language.add(new Option(option.text, option.value, option.defaultSelected, option.selected));
        });

        requestAnimationFrame(() => {
          this.targets.language.disabled = false;
        });
      });
  }
}

if (!customElements.get('localization-form')) customElements.define('localization-form', LocalizationForm);
